import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { GridDataResult } from "@progress/kendo-angular-grid";
import { DataSourceRequestState, DataResult } from "@progress/kendo-data-query";
import { BehaviorSubject } from "rxjs";
import { Branch } from "./branch.classes";
import { AppConstant } from "src/app/app.constant";

@Injectable()
export class BranchService {
  apiUrl: string;
  kendoDataUrl: string;

  constructor(
    private httpClient: HttpClient,
    private appConstant: AppConstant
  ) {
    this.apiUrl = this.appConstant.getUrl();
  }
  manageBranch(BranchData: Branch) {
    return this.httpClient.post(`${this.apiUrl}/manageBranch`, BranchData).pipe(
      map((response: any) => {
        return response;
      })
    );
  }
  public getAllBranch(): Observable<DataResult> {
    return this.httpClient.get(`${this.apiUrl}/getAllBranch/`).pipe(
      map((response: any) => {
        return {
          data: response.data,
          total: response.total,
        } as GridDataResult as any;
      })
    ) as any as Observable<GridDataResult>;
  }
  getBranchById(branchId) {
    return this.httpClient.get(`${this.apiUrl}/getBranchById/` + branchId).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  // To set setup assistant data
  updateSetupAssistant(setupData) {
    return this.httpClient.post(`${this.apiUrl}/updateSetupAssistant`, setupData).pipe(
      map((response: any) => {
        return response;
      })
    );
  }
  getSetupAssistant() {
    return this.httpClient.get(`${this.apiUrl}/getSetupAssistantData/`).pipe(
      map((response: any) => {
        return response.data;
      })
    );
  }
}
